export const newsletterPopup = () => {
  // Open newsletter if anchor is in URL
  if (window.location.href.toString().includes('#newsletter')) {
    document.querySelector("a[href='#signup-popup']").click();
  }
};
